export const PLACE_PHOTO = {
    width: { xs: '100%', sm: 150 },
    height: { xs: 180, sm: 150 }
};

export const PLACE_BUTTON = {
    height: 32,
    borderRadius: 2,
    minWidth: 90
};

export const PLACE_CONTENT_HEIGHT = 150;
export const PLACE_DESCRIPTION_LIMIT = 500;
export const PLACE_TITLE_LIMIT = 60;
